import { AccountLevelArkchatPermission, GroupLevelArkchatPermission, TaskStatus } from "./constant";
import { groupExternalMember } from "./externalMemberGroping";

export function findUser(usersData, userDataToFind) {
  const internalMember = Array.isArray(usersData?.internalMember)
    ? usersData.internalMember
    : [];
  const externalMember = Array.isArray(usersData?.externalMember)
    ? usersData.externalMember
    : [];
  const user = [
    ...internalMember,
    ...externalMember,
  ]?.find((userData) => userData?.userId === userDataToFind);
  return user;
}
export function findGroupRecipientData(usersData, userDataToFind) {
  const user = usersData?.find(
    (userData) => userData?.userId === userDataToFind,
  );
  return user;
}

export const setProfileData = (
  data,
  setProfileViewData,
  setProfileViewModal,
) => {
  const viewData = {
    companyName: data?.userData?.subscriberFirmName || "",
    userName: data?.userInfo
      ? `${data?.userInfo?.firstName} ${data?.userInfo?.lastName}`
      : `${data?.firstName} ${data?.lastName}`,
    industryName:
      data?.userData?.subscriberAccountIndustry ||
      data?.activeSubscriber?.subscriberAccountIndustry,
    cityName: data?.userData?.city || data?.city,
    countryName: data?.userData?.country || data?.country,
    profileBrief: data?.userInfo?.profileBrief || data?.profileBrief,
    profileImgUrl: data?.userInfo?.profileImgUrl || data?.profileImgUrl,
    coverImgUrl: data?.userInfo?.coverImgUrl || data?.coverImgUrl,
    isGroup: false,
    website: data?.userInfo?.website || data?.website,
    linkedin: data?.userInfo?.linkedin || data?.linkedin,
  };

  setProfileViewData(viewData);
  setProfileViewModal(true);
};

// A group member's profile card. Their entry in the group's people (member,
// when they're in it) has what the card shows except their profile's own
// fields (bio, cover image, website, LinkedIn): the card opens with the
// entry, and those fill in when their profile (loadProfile(userId)) comes.
// Someone not in it: the card opens with their profile.
export const showMemberProfile = (
  member,
  userId,
  loadProfile,
  setProfileViewData,
  setProfileViewModal,
) => {
  if (!member) {
    setProfileViewModal(true);
    loadProfile(userId)
      ?.then((profile) => setProfileData(profile, setProfileViewData, setProfileViewModal))
      .catch(() => {});
    return;
  }
  setProfileData(
    member,
    (viewData) => setProfileViewData({ ...viewData, memberId: userId }),
    setProfileViewModal,
  );
  fillProfileCard(userId, loadProfile, setProfileViewData);
};

// Fills a profile card (one whose memberId is userId) with these fields of
// the person's profile (loadProfile(userId)), which member lists don't
// carry; only if the card still shows them (another may have opened since).
export const fillProfileCard = (
  userId,
  loadProfile,
  setProfileViewData,
  fields = ["profileBrief", "coverImgUrl", "website", "linkedin"],
) => {
  loadProfile(userId)
    ?.then((profile) => {
      if (!profile) return;
      setProfileViewData((prev) =>
        prev?.memberId !== userId
          ? prev
          : {
              ...prev,
              ...Object.fromEntries(fields.map((field) => [field, profile[field] || prev[field]])),
            },
      );
    })
    .catch(() => {});
};

export function checkDoesHaveSid(sidList, sid) {
  const isSidPresent = sidList?.find((item) => item?.id === sid);
  return isSidPresent;
}

export function getLast12Months() {
  const months = [];
  const currentDate = new Date();

  for (let i = 0; i < 12; i++) {
    // Create a new date for each month
    const monthDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - i,
      1,
    );
    // Get the month and year
    const monthName = monthDate.toLocaleString("default", { month: "long" }); // Full month name
    const year = monthDate.getFullYear();
    months.push(`${monthName} ${year}`);
  }

  return months.reverse(); // Reverse to get the order from the past to the present
}

export function categorizeRecipients(memberDetails, recipientData) {
  const internal = [];
  const external = [];

  if (!memberDetails || !Array.isArray(memberDetails)) {
    return { internal, external };
  }

  if (!recipientData || !Array.isArray(recipientData)) {
    return { internal, external };
  }

  const memberUserIds = new Set();
  memberDetails.forEach((member) => {
    if (member?.userId != null) {
      memberUserIds.add(member.userId);
    }
  });

  recipientData.forEach((recipient) => {
    if (recipient?.userId != null) {
      if (memberUserIds.has(recipient.userId)) {
        internal.push(recipient);
      } else {
        external.push(recipient);
      }
    } else {
      external.push(recipient);
    }
  });

  return { internal, external };
}
export const handleSelected = ({
  groupmemberdetails,
  groupRecipientDetails,
  taskData,
  setSelectedRecipients,
  appContent,
  selectedRecipients,
}) => {
  const { internal: internalGroupRecipient, external: externalGroupRecipient } =
    categorizeRecipients(
      groupmemberdetails?.internalMember,
      groupRecipientDetails,
    );
  let coreMemberInternal = [];
  let coreMemberExternal = [];
  if (taskData) {
    coreMemberInternal = internalGroupRecipient?.filter((item) =>
      taskData?.participants?.includes(item.userId),
    );
    coreMemberExternal = externalGroupRecipient?.filter((item) =>
      taskData?.participants?.includes(item.userId),
    );
    const threadCoreExternalMemberData = groupExternalMember(
      coreMemberExternal,
      true,
      appContent?.KEY34,
    );
    let extgrpMemberObj = {};
    threadCoreExternalMemberData.forEach((company, index) => {
      const companyValues = Object.values(company)[0];
      const userIds = companyValues?.map((item) => item?.userId);
      const companyName = Object.keys(company)[0];
      const companyUserId = { [companyName]: userIds };
      extgrpMemberObj = { ...extgrpMemberObj, ...companyUserId };
    });
    setSelectedRecipients({
      ...selectedRecipients,
      selectedInternalRecipients: coreMemberInternal,
      selectedExternalRecipients: coreMemberExternal,
    });
  }
};

export function checkParticularSubscriptionCanceled(subsData, planType) {
  if (subsData?.length > 0) {
    for (let i = 0; i < subsData?.length; i++) {
      if (subsData[i]?.planType === planType && subsData[i]?.isCancelled) {
        return true;
      }
    }
    return false;
  }
  return false;
}

export function checkAllSubscriptionCanceled(subsData) {
  if (subsData?.length > 0) {
    for (let i = 0; i < subsData?.length; i++) {
      if (!subsData[i]?.isCancelled) {
        return false;
      }
    }
    return true;
  }
  return false;
}

export function logWrapper(...args) {
  if (process.env.NODE_ENV === "development") {
    console.log(...args);
  }
}

export const getOrdinal = (n) => {
  const s = ["th", "st", "nd", "rd"], // suffix options
    v = n % 100; // last 2 digits of the number
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const session = {
  set(key, value) {
    try {
      const data = typeof value === "string" ? value : JSON.stringify(value);
      sessionStorage.setItem(key, data);
    } catch (error) {
      console.error("SessionStorage Set Error:", error);
    }
  },

  get(key) {
    try {
      const value = sessionStorage.getItem(key);
      if (!value) return null;
      // If JSON, parse it safely
      try {
        return JSON.parse(value);
      } catch {
        return value; // If it's plain string
      }
    } catch (error) {
      console.error("SessionStorage Get Error:", error);
      return null;
    }
  },

  remove(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error("SessionStorage Remove Error:", error);
    }
  },

  clear() {
    try {
      sessionStorage.clear();
    } catch (error) {
      console.error("SessionStorage Clear Error:", error);
    }
  },
};

export const parseInviteData = (decryptedStr) => {
  if (!decryptedStr) return null;

  const params = new URLSearchParams(decryptedStr);

  return {
    inviteType: params.get("inviteType"),
    inviteName: params.get("inviteName"),
    subscriberId: params.get("subscriberId"),
    token: params.get("token"),
  };
};

export const getInvitationDataFromStorage = () => {
  const invData = JSON.parse(localStorage.getItem("invitationData")) || false;
  if (invData) {
    return invData;
  }

  return false;
};

export const uploadFileCache = new Map();

// The viewer's entry in a message says which language they read it in. Someone
// else's message may have been sent before they changed language, or by an app
// that hadn't heard yet: it's the language they have now. Their own messages
// stay as they are, so they keep reading what they wrote.
export const withViewerLanguage = (message, currentUserData) => {
  const id = currentUserData?.id;
  const language = currentUserData?.languageCode;
  if (!language || !Array.isArray(message?.to) || String(message?.from?.id) === String(id)) {
    return message;
  }
  return {
    ...message,
    to: message.to.map((user) =>
      String(user?.id) === String(id) ? { ...user, languageCode: language } : user,
    ),
  };
};

// A message's text as the viewer reads it: their translation when there is one.
export const messageTextFor = (message, currentUserData) => {
  const language = message?.to?.find(
    (user) => String(user?.id) === String(currentUserData?.id),
  )?.languageCode;
  return (language && message?.translations?.[language]) || message?.message;
};

// Text shown for a message being replied to: the viewer's translation when
// there is one, otherwise the original text (as the message list does). A
// message received live has no translations until it's saved and re-fetched,
// and the sender isn't always in `to`; both used to show "undefined...".
export const replyPreviewText = (message, currentUserData) => {
  const languageCode = message?.to?.find(
    (user) => user?.id === currentUserData?.id,
  )?.languageCode;
  const text =
    (languageCode && message?.translations?.[languageCode]) ||
    message?.message ||
    "";
  return text.length > 200 ? `${text.slice(0, 200)}...` : text;
};

export default session;

const normalizeGroupMemberList = (groupmember) => {
  if (Array.isArray(groupmember)) {
    return groupmember;
  }

  if (!groupmember || typeof groupmember !== "object") {
    return [];
  }

  const internalMember = Array.isArray(groupmember?.internalMember)
    ? groupmember.internalMember
    : [];
  const externalMember = Array.isArray(groupmember?.externalMember)
    ? groupmember.externalMember
    : [];
  const internal = Array.isArray(groupmember?.internal)
    ? groupmember.internal
    : [];
  const external = Array.isArray(groupmember?.external)
    ? groupmember.external
    : [];

  return [...internalMember, ...externalMember, ...internal, ...external];
};

export const showUpdateTaskButton = (currentUser, taskData, groupmember) => {

  const groupList = normalizeGroupMemberList(groupmember);

  const assignerSubscriber = taskData?.from?.target_subscriber_id;
  const assigneeSubscriber = taskData?.assignee?.target_subscriber_id;

  const currentUserSubscriber = groupList.find(
    (userDetail) => currentUser?.id === userDetail?.userId
  );

  const isAssignerInternal =
    assignerSubscriber === currentUserSubscriber?.targetSubscriberId;

  const isAssigneeInternal =
    assigneeSubscriber === currentUserSubscriber?.targetSubscriberId;

  const isAdmin =
    currentUserSubscriber?.accountPermission ===
    AccountLevelArkchatPermission.ADMIN;

  const isAssigner = taskData?.from?.id === currentUser?.id;
  const isAssignee = taskData?.assignee?.id === currentUser?.id;

  const status = taskData?.task_status;

  if (
    (isAssignerInternal && isAssigneeInternal) ||
    (isAssignerInternal && !isAssigneeInternal) ||
    (!isAssignerInternal && isAssigneeInternal)
  ) {
    if (
      ((isAssigner || isAdmin) && status !== TaskStatus?.Cancelled) ||
      (isAssignee && status === TaskStatus?.Started)
    ) {
      return true;
    }
  }

  return false;
};

export const taskUpdateMenuList = (currentUser, taskData, groupmember) => {
  const groupList = normalizeGroupMemberList(groupmember);

  const availableOptions = [
    { title: `Cancel or close the task`, value: `cancelTask` },
    { title: `Reopen done task`, value: `reopen` },
    { title: `Reassign to someone else`, value: `reassignTask` },
    {
      title: `Change task date | Time | Priority`,
      value: `changeValues`,
    },
    ...(taskData?.task_status !== TaskStatus?.Done && taskData?.task_status !== TaskStatus?.Cancelled && taskData?.task_status !== TaskStatus?.Started
      ? [{ title: `Change task to approval request`, value: `changeType` }]
      : []),
  ];

  let allowedValues = [];

  const currentUserSubscriber = groupList.find((userDetail) => currentUser?.id === userDetail?.userId);

  const isAssignerInternal = currentUserSubscriber?.targetSubscriberId === taskData?.from?.target_subscriber_id;

  const isAssigneeInternal = currentUserSubscriber?.targetSubscriberId === taskData?.assignee?.target_subscriber_id;
  const iscurrentUserInternal = (currentUserSubscriber?.targetSubscriberId === taskData?.from?.target_subscriber_id && currentUserSubscriber?.targetSubscriberId === taskData?.assignee?.target_subscriber_id); // this check is in ref to assigner and assinee

  const isAssignerInGroup = groupList.find((userData) => userData?.userId === taskData?.from?.id);
  const isAssigneeInGroup = groupList.find((userData) => userData?.userId === taskData?.assignee?.id);

  const currentGroupRelatedOwner = currentUser?.subscribedTo?.some((item)=>item?.id === currentUserSubscriber?.targetSubscriberId && item?.accountOwner === currentUserSubscriber?.userId);

  const isCurrentUserAccountOwner = currentUserSubscriber?.accountPermission === AccountLevelArkchatPermission?.ADMIN && currentGroupRelatedOwner;
  const isCurrentUserAccountAdmin = currentUserSubscriber?.accountPermission === AccountLevelArkchatPermission?.ADMIN && !currentGroupRelatedOwner;

  const isAssignerOwner = currentUser?.subscribedTo?.some((item)=> item?.id === taskData?.from?.target_subscriber_id && item?.accountOwner === taskData?.from?.id);
  const isAssignerAdmin = currentUser?.subscribedTo?.some((item)=> item?.id === taskData?.from?.target_subscriber_id && item?.accountOwner !== taskData?.from?.id && isAssignerInGroup?.accountPermission === AccountLevelArkchatPermission?.ADMIN);

  



  if (currentUser?.id === taskData?.from?.id) {
    allowedValues = ["cancelTask", "reopen", "reassignTask", "changeValues", "changeType",];
  }
  // parent case 1: Assigner and Assignee both internal
  else if (isAssignerInternal && isAssigneeInternal && iscurrentUserInternal) {

    if(isAssignerInGroup?.userId && isAssigneeInGroup?.userId){ // means Assigner and Assignee user in group

          if (isCurrentUserAccountAdmin && currentUser?.id === isAssigneeInGroup?.userId && isAssignerOwner) {

            allowedValues = ["reassignTask"];

          } else if (isCurrentUserAccountOwner && currentUser?.id === isAssigneeInGroup?.userId && isAssignerInGroup?.accountPermission === AccountLevelArkchatPermission?.ADMIN) {

            allowedValues = ["cancelTask", "reassignTask", "changeValues",];

          } else if ((isCurrentUserAccountOwner || isCurrentUserAccountAdmin) && (currentUser?.id !== isAssigneeInGroup?.userId && currentUser?.id !== isAssignerInGroup?.userId)) {
            allowedValues = ["cancelTask", "reopen", "reassignTask", "changeValues", "changeType",];

          }else if ((isCurrentUserAccountOwner || isCurrentUserAccountAdmin) && (currentUser?.id === isAssigneeInGroup?.userId || currentUser?.id === isAssignerInGroup?.userId)) {
            allowedValues = ["cancelTask", "reassignTask", "changeValues" ];

          }
    } else { // means Assigner and Assignee user removed from group so admin and owner will see full option
        if(isCurrentUserAccountOwner||isCurrentUserAccountAdmin) {
          allowedValues = ["cancelTask", "reopen", "reassignTask", "changeValues", "changeType",];
        }
    }
  
  } else {
    if(isAssignerInGroup?.userId && isAssigneeInGroup?.userId) {
      if ((isAssignerOwner||isAssignerAdmin||(!isAssignerOwner && !isAssignerAdmin)) && (isCurrentUserAccountOwner || isCurrentUserAccountAdmin)) {
        if (taskData?.from?.target_subscriber_id === currentUserSubscriber?.targetSubscriberId) {
          allowedValues = [ "cancelTask", "reopen", "reassignTask", "changeValues", "changeType"];
        } else {
          allowedValues = ["reassignTask"];
        }
    }
     
    }
  }
  return availableOptions.filter((option) =>
    allowedValues.includes(option.value),
  );

};

// Who manages a group (its Add Member list, making members managers,
// renaming it, its settings): the account's admins and owner (managers by
// default, for their own account's groups) and members made the group's
// managers. Plain members don't.
// groupPermissionType: the current user's role in the group.
// isExternalGroup: the group belongs to another account (I'm an external
// collaborator there), so my admin/owner role doesn't apply.
export const canManageGroup = (currentUserData, groupPermissionType, isExternalGroup = false) =>
  Boolean(
    (!isExternalGroup &&
      (currentUserData?.accountOwner ||
        currentUserData?.activePermission === AccountLevelArkchatPermission.ADMIN)) ||
      groupPermissionType === GroupLevelArkchatPermission.MANAGER ||
      groupPermissionType === GroupLevelArkchatPermission.OWNER
  );
